var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Pedidos Perseo"},on:{"click":function($event){_vm.menu = 1}}})],1),(_vm.menu == 0)?_c('div',[_c('listadoProfVue')],1):_vm._e(),(_vm.menu == 1)?_c('div',[_c('listadoPerseoVue',{attrs:{"periodoSelect":_vm.periodoSelect}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }